export const messages: Record<string, string> = {
  // Common
  DatabaseUpdateError: 'An error occurred while updating the database.',

  // TenantRequest - Success
  'TenantRequest.Created':
    'Thank you! Your request has been submitted. Our team will contact you shortly.',
  'TenantRequest.Updated': 'Request updated successfully.',
  'TenantRequest.Deleted': 'Request deleted successfully.',
  'TenantRequest.Approved': 'Request approved successfully.',
  'TenantRequest.Rejected': 'Request rejected successfully.',

  // TenantRequest - Errors
  'TenantRequest.IdEmpty': 'Tenant request ID cannot be empty.',
  'TenantRequest.PredicateNull': 'Predicate cannot be null.',
  'TenantRequest.NotFound': 'Tenant request with specified ID not found.',
  'TenantRequest.DataNull': 'Tenant request data cannot be null.',
  'TenantRequest.ValidationFailed': 'Validation failed.',
  'TenantRequest.BusinessNameRequired': 'Business name is required.',
  'TenantRequest.ContactPhoneRequired': 'Contact phone is required.',
  'TenantRequest.PhoneAlreadyExists': 'A tenant request with this phone number already exists.',
  'TenantRequest.DatabaseCreateError': 'Failed to create tenant request due to database error.',
  'TenantRequest.DatabaseUpdateError': 'Failed to update tenant request due to database error.',
  'TenantRequest.ConcurrencyUpdateError': 'Concurrency error updating tenant request.',
  'TenantRequest.ConcurrencyApprovalError': 'Concurrency error approving tenant request.',
  'TenantRequest.ConcurrencyRejectError': 'Concurrency error rejecting tenant request.',
  'TenantRequest.SubdomainInUse': 'Subdomain already in use.',
  'TenantRequest.ReviewedByUserIdEmpty': 'Reviewed by user ID cannot be empty.',
  'TenantRequest.RejectionReasonRequired': 'Rejection reason is required.',
  'TenantRequest.DatabaseDeleteError': 'Failed to delete tenant request due to database error.',
  'TenantRequest.NotFoundOrDeleteFailed': 'Tenant request not found or could not be deleted.',

  // Auth - Success
  'Auth.LoginSuccess': 'Login successful.',
  'Auth.OtpSent': 'OTP sent successfully.',
  'Auth.PasswordResetSuccess': 'Password reset successfully.',
  'Auth.TokenRefreshed': 'Token refreshed successfully.',
  'Auth.LogoutSuccess': 'Logout successful.',

  // Auth - Errors
  'Auth.ValidationFailed': 'Validation errors occurred.',
  'Auth.EmailOrPhoneRequired': 'Phone number or email is required.',
  'Auth.PasswordRequired': 'Password is required.',
  'Auth.InvalidCredentials': 'Invalid phone number or password.',
  'Auth.AccountLocked': 'Account is locked. Try again later.',
  'Auth.PasswordResetRequired': 'Password reset required. Please reset your password to continue.',
  'Auth.UserInactive': 'User is inactive.',
  'Auth.RefreshTokenRequired': 'Refresh token is required.',
  'Auth.InvalidRefreshToken': 'Invalid refresh token.',
  'Auth.UserNotFound': 'User not found.',
  'Auth.PhoneRequired': 'Phone number is required.',
  'Auth.OtpRequired': 'OTP is required.',
  'Auth.NewPasswordRequired': 'New password is required.',
  'Auth.PasswordsDoNotMatch': 'Passwords do not match.',
  'Auth.InvalidOrExpiredOtp': 'Invalid or expired OTP.',

  // Tenant - Success
  'Tenant.Created': 'Tenant has been created successfully.',
  'Tenant.Updated': 'Tenant has been updated successfully.',
  'Tenant.Deleted': 'Tenant has been deleted successfully.',
  'Tenant.Exists': 'Tenant already exists.',
  'Tenant.Activated': 'Tenant has been activated.',
  'Tenant.Suspended': 'Tenant has been suspended.',
  'Tenant.TrialStarted': 'Tenant trial has started.',

  // Tenant - Errors
  'Tenant.IdEmpty': 'Tenant ID cannot be empty.',
  'Tenant.DataNull': 'Tenant data cannot be null.',
  'Tenant.NotFound': 'Tenant not found.',
  'Tenant.NotFoundWithId': 'Tenant with the specified ID was not found.',
  'Tenant.NotFoundWithSubdomain': 'Tenant with the specified subdomain was not found.',
  'Tenant.NotFoundWithIdentifier': 'Tenant with the specified identifier was not found.',
  'Tenant.NotFoundWithPlanId': 'Tenant with the specified plan ID was not found.',
  'Tenant.ValidationFailed': 'Tenant validation failed.',
  'Tenant.BusinessNameRequired': 'Business name is required.',
  'Tenant.IdentifierRequired': 'Identifier is required.',
  'Tenant.ContactPhoneRequired': 'Contact phone is required.',
  'Tenant.SubdomainRequired': 'Subdomain is required.',
  'Tenant.DatabaseNameRequired': 'Database name is required.',
  'Tenant.PredicateNull': 'Predicate cannot be null.',
  'Tenant.SubdomainEmpty': 'Subdomain cannot be empty.',
  'Tenant.IdentifierEmpty': 'Identifier cannot be empty.',
  'Tenant.SubdomainInUse': 'Subdomain is already in use.',
  'Tenant.IdentifierInUse': 'Identifier is already in use.',
  'Tenant.DatabaseCreateError': 'Failed to create tenant due to a database error.',
  'Tenant.DatabaseUpdateError': 'Failed to update tenant due to a database error.',
  'Tenant.DatabaseDeleteError': 'Failed to delete tenant due to a database error.',
  'Tenant.ConcurrencyUpdateError': 'Concurrency error occurred while updating tenant.',
  'Tenant.NotFoundOrDeleteFailed': 'Tenant not found or delete operation failed.',

  // Shop - Success
  'Shop.Created': 'Shop has been created successfully.',
  'Shop.Updated': 'Shop has been updated successfully.',
  'Shop.Deleted': 'Shop has been deleted successfully.',

  // Shop - Error
  'Shop.CreateValidationFailed': 'Shop creation validation failed.',
  'Shop.DatabaseCreateError': 'Failed to create shop due to database error.',

  // ShopItem - Success
  'ShopItem.Created': 'Shop item has been created successfully.',
  'ShopItem.Updated': 'Shop item has been updated successfully.',
  'ShopItem.Deleted': 'Shop item has been deleted successfully.',

  // ShopItem - Errors
  'ShopItem.CreateValidationFailed': 'Shop item creation validation failed.',
  'ShopItem.DatabaseCreateError': 'Failed to create shop item due to database error.',
  'ShopItem.NotFound': 'Shop item not found.',

  // ItemUnit - Success
  'ItemUnit.Created': 'Item unit has been created successfully.',
  'ItemUnit.Updated': 'Item unit has been updated successfully.',
  'ItemUnit.Deleted': 'Item unit has been deleted successfully.',

  // ItemUnit - Errors
  'ItemUnit.CreateValidationFailed': 'Item unit creation validation failed.',
  'ItemUnit.DatabaseCreateError': 'Failed to create item unit due to database error.',
  'ItemUnit.NotFound': 'Item unit not found.',
  'ItemUnit.ValidationFailed': 'Item unit validation failed.',
  'ItemUnit.DatabaseUpdateError': 'Failed to update item unit due to database error.',
  'ItemUnit.DatabaseDeleteError': 'Failed to delete item unit due to database error.',
  'ItemUnit.ConcurrencyUpdateError': 'Concurrency error updating item unit.',

  // PurchaseInvoice - Success
  'PurchaseInvoice.Created': 'Purchase invoice has been created successfully.',
  'PurchaseInvoice.Updated': 'Purchase invoice has been updated successfully.',
  'PurchaseInvoice.Deleted': 'Purchase invoice has been deleted successfully.',

  // PurchaseInvoice - Errors
  'PurchaseInvoice.CreateValidationFailed': 'Purchase invoice creation validation failed.',
  'PurchaseInvoice.DatabaseCreateError': 'Failed to create purchase invoice due to database error.',
  'PurchaseInvoice.NotFound': 'Purchase invoice not found.',
  'PurchaseInvoice.ValidationFailed': 'Purchase invoice validation failed.',
  'PurchaseInvoice.DatabaseUpdateError': 'Failed to update purchase invoice due to database error.',
  'PurchaseInvoice.DatabaseDeleteError': 'Failed to delete purchase invoice due to database error.',
  'PurchaseInvoice.ConcurrencyUpdateError': 'Concurrency error updating purchase invoice.',

  // Inventory - Success
  'Inventory.Added': 'Inventory has been added successfully.',
  'Inventory.Updated': 'Inventory has been updated successfully.',
  'Inventory.Deactivated': 'Inventory has been deactivated successfully.',

  // Inventory - Errors
  'Inventory.NotFound': 'Inventory not found.',
  'Inventory.DatabaseCreateError': 'Failed to create inventory due to database error.',
  'Inventory.DatabaseUpdateError': 'Failed to update inventory due to database error.',
  'Inventory.ValidationFailed': 'Inventory validation failed.',

  // SellInvoice - Success
  'SellInvoice.Created': 'Sell invoice has been created successfully.',
  'SellInvoice.AlreadyExists': 'Sell invoice already exists.',
  'SellInvoice.Updated': 'Sell invoice has been updated successfully.',
  'SellInvoice.Deleted': 'Sell invoice has been deleted successfully.',

  // SellInvoice - Errors
  'SellInvoice.CreateValidationFailed': 'Sell invoice creation validation failed.',
  'SellInvoice.DatabaseCreateError': 'Failed to create sell invoice due to database error.',
  'SellInvoice.DatabaseUpdateError': 'Failed to update sell invoice due to database error.',
  'SellInvoice.NotFound': 'Sell invoice not found.',
  'SellInvoice.ValidationFailed': 'Sell invoice validation failed.',
  'SellInvoice.ConcurrencyUpdateError': 'Concurrency error updating sell invoice.',
};

export function getMessageByKey(key: string, fallback = 'An unexpected error occurred.') {
  console.log('Retrieving message for key:', key);
  return messages[key] || fallback;
}
